const priorityRequests = {
  title: "Vormerkliste für rascheren 1B Termin",
  filter: {
    counselor: "Berater:in",
    allCounselors: "Alle Berater:innen",
    reachability: "Erreichbarkeit",
    reachabilityOptions: {
      All: "Alle",
      Reachable: "Nur aktuell erreichbar",
      NotReachable: "Nur nicht erreichbar",
    },
    form: "1B-Formulare",
    formOptions: {
      All: "Alle",
      Prepared: "Nur mit vorbereitetem 1B-Formular",
      NotPrepared: "Nur mit unvorbereitetem 1B-Formular",
    },
  },
  columns: {
    caseNumber: "EDV-#",
    client: "Kund:in",
    counselor: "Berater:in",
    form: "1B-Formular",
    appointment: "1B Termin",
    reachability: "Erreichbarkeit",
    lastContactAttempt: "Letzter Kontaktversuch",
  },
  weekdays: {
    Monday: "Mo",
    Tuesday: "Di",
    Wednesday: "Mi",
    Thursday: "Do",
    Friday: "Fr",
    Saturday: "Sa",
    Sunday: "So",
  },
  menu: {
    ariaLabel: "Aktionen für {{name}}",
    pullForward: "Vormerkung vorziehen und beraten",
    contactAttempt: "Kontaktversuch eintragen",
    delete: "Vormerkung löschen",
  },
  pullForward: {
    confirmTitle: "Vormerkung vorziehen",
    confirmText: "Soll der ursprünglich geplante Termin vorgezogen werden? Es werden dann:",
    consequences: {
      release: "der ursprüngliche Termin neu zur Verfügung gestellt",
      create: "ein neuer 1B-Kalendereintrag mit dem Vermerk „vorgezogen“ angelegt",
      assign: "dieser neu angelegte Termin sofort hier vergeben.",
    },
    confirm: "Vorziehen",
    success: "Die Vormerkung wurde vorgezogen.",
  },
  contactAttempt: {
    confirmTitle: "Kontaktversuch eintragen",
    confirmText:
      "Soll der Kontaktversuch eingetragen werden? Es wird dann ein AV über den fehlgeschlagenen Kontaktversuch als Telefonat eingetragen.",
    confirm: "Eintragen",
    success: "Der Kontaktversuch wurde eingetragen.",
  },
  delete: {
    confirmTitle: "Vormerkung löschen",
    confirmText: "Soll die Vormerkung gelöscht werden? Der gebuchte 1B-Termin bleibt bestehen.",
    confirm: "Löschen",
    success: "Die Vormerkung wurde gelöscht.",
  },
  noReachabilityStated: "keine Angabe",
  noContactAttempt: "noch keiner",
  empty: "Keine Vormerkungen entsprechen den gewählten Filtern.",
  error: "Die Vormerkliste konnte nicht geladen werden.",
  widget: {
    title: "Vormerkungen ({{count}})",
    showAll: "Zur Vormerkliste",
    counselor: "Berater:in der Vormerkungen",
    appointment: "1B-Termin",
    form: "Formular",
    contact: "Kontakt",
    empty: "Aktuell sind keine Kund:innen mit Vormerkung erreichbar.",
  },
};

export default priorityRequests;
